<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">

      <!-- En-tête -->
      <div class="row mb-5">
        <div class="col-12 text-center">
          <!-- <h2 class="section-title">Équipe d’Animateurs et Animatrices</h2> -->
          <p class="section-subtitle">
            L’Equipe d’Animateurs et Animatrices assure la formation chrétienne sur les paroisses et dans les groupes et associations, à travers conférences ou récollections et présence sur les réseaux sociaux. Elle est constituée de disciples d’Emmaüs ayant régulièrement suivi avec succès au moins un parcours de 2 ans à l’EITP et désireux de partager la formation reçue avec leurs frères et sœurs.
          </p>
        </div>
      </div>

      <!-- Rôle et mission -->
      <div class="row justify-content-center mb-5">
        <div class="col-lg-8">
          <div class="tutor-card">
            <h3 class="tutor-section-title">Rôle et mission</h3>
            <ul class="tutor-list">
              <li>Assurer la formation chrétienne sur les paroisses et au sein des groupes et associations.</li>
              <li>Organiser et animer des conférences, récollections et autres activités spirituelles.</li>
              <li>Être présents sur les réseaux sociaux pour partager des contenus de formation et renforcer la cohésion.</li>
              <li>Transmettre les valeurs et l’esprit du parcours EITP aux disciples et nouveaux participants.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row g-4 mt-3">
      <div
        class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
        v-for="etu in etudiants"
        :key="etu.id"
      >
        <div class="prof-mini-card">
          <img
            v-if="etu.user?.urlImage"
            :src="getImageUrl(etu.user.urlImage)"
            alt="Photo disciple"
            class="prof-photo"
          />

          <img
            v-else
            :src="defaultPhoto"
            alt="Photo par défaut"
            class="prof-photo"
          />
          <h5 class="prof-mini-name">
            <router-link
              :to="`/disciplesEmmaius/${etu.id}`"
              class="prof-link"
            >
              {{ etu.nom }} {{ etu.prenom }}
            </router-link>
          </h5>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <PaginationComponent
        :page="page"
        :totalPages="totalPages"
        :totalElements="totalElements"
        :limit="limit"
        @paginate="handlePaginate"
      />
    </div>

    </div>
    
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import debounce from "lodash/debounce";

interface Etudiant {
  id: number;
  nom: string;
  prenom: string;
  photo: string;
  autreQualification:string
  user?:User
}
interface User {
  urlImage?: string
}


export default defineComponent({
  name: "LesDisciplesEmmaus",
  components: { PaginationComponent },

  setup() {
    const etudiants = ref<Etudiant[]>([]);
    const defaultPhoto = "/22.png";

    const page = ref(1);
    const limit = ref(12);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const searchTerm = ref('');
   

    // Pagination handler
    const handlePaginate = ({ page_: newPage, limit_: newLimit }) => {
      page.value = newPage;
      limit.value = newLimit;
      getTreeDisciples(newPage, newLimit);
    };
    function rechercher(){
      getTreeDisciples(page.value, limit.value, searchTerm.value );
    }
    // Chargement des étudiants
    const getTreeDisciples = async (pageNum = 1, limi = 12, searchTerm='') => {
      try {
        const { data } = await ApiService.get(
          `/formateurs/Animateur?page=${pageNum}&limit=${limi}&mot=${searchTerm}&`
        );
        console.log("RESPONSE ===>", data);

        etudiants.value = data.data.data;
        console.log("gggg",etudiants.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;

      } catch (error) {
        console.error("Erreur chargement disciples :", error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    // Chargement initial
    onMounted(() => {
      getTreeDisciples(page.value, limit.value);
    });

    return {
      etudiants,
      defaultPhoto,
      page,
      limit,
      totalPages,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getImageUrl
    };
  },
});
</script>

<style scoped>
/* On peut réutiliser exactement les mêmes styles que le composant tutorat */
.service-wrap {
  background-color: #f8f9fa;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
  max-width: 1000px; /* Limite la largeur du texte */
  margin-left: auto;
  margin-right: auto; /* Centre le texte */
  line-height: 1.6; /* Améliore la lisibilité */
  text-align: center; /* Centre le texte sur la ligne */
}

.tutor-card {
  background: white;
  border-radius: 15px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.tutor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.tutor-section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.tutor-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.tutor-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
  font-size: 0.95rem;
  color: #6c757d;
}

.tutor-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ffc107; /* petit accent jaune */
}

.section-text {
    font-size: 20px
  }
  .prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;

  .year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

}

.search-wrapper {
  display: flex;
  justify-content: flex-start;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}

.search-box input {
  width: 200%;
  height: 48px;
  padding: 0 50px 0 18px;
  border-radius: 15px;
  border: 2px solid #e6e6e6;
  font-size: 20px;
  color: #0b1b3f;
  transition: all 0.3s ease;
  background-color: #fff;
}

.search-box input::placeholder {
  color: #999;
  font-size: 20px;
}

.search-box input:focus {
  outline: none;
  border-color: #ffc107;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.15);
}

.search-box button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #ffc107;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.search-box button:hover {
  color: #0b1b3f;
  transform: translateY(-50%) scale(1.1);
}

/* Responsive */
@media (max-width: 576px) {
  .search-wrapper {
    justify-content: center;
  }

  .search-box {
    max-width: 100%;
  }
}

.section-text {
    font-size: 20px
  }
  .prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;

  .year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

}

.search-wrapper {
  display: flex;
  justify-content: flex-start;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}

.search-box input {
  width: 200%;
  height: 48px;
  padding: 0 50px 0 18px;
  border-radius: 15px;
  border: 2px solid #e6e6e6;
  font-size: 20px;
  color: #0b1b3f;
  transition: all 0.3s ease;
  background-color: #fff;
}

.search-box input::placeholder {
  color: #999;
  font-size: 20px;
}

.search-box input:focus {
  outline: none;
  border-color: #ffc107;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.15);
}

.search-box button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #ffc107;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.search-box button:hover {
  color: #0b1b3f;
  transform: translateY(-50%) scale(1.1);
}

/* Responsive */
@media (max-width: 576px) {
  .search-wrapper {
    justify-content: center;
  }

  .search-box {
    max-width: 100%;
  }
}
</style>
